import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/auth-section/auth-service/auth.service';
import { DoctorsService } from 'src/app/doctor-section/doctor-service/doctors.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from "primeng/api";
import { MessageService } from "primeng/api";
import { take } from 'rxjs/operators';
import { HosdocService } from './hosdoc-service/hosdoc.service';

@Component({
  selector: 'app-hospital-doctors',
  templateUrl: './hospital-doctors.component.html',
  styleUrls: ['./hospital-doctors.component.css'],
  providers:[MessageService,ConfirmationService]
})
export class HospitalDoctorsComponent implements OnInit {

  isData=true
  docArray=[]
  searchQuery = null;
  token: string;
  filter;
  page = 1;
  isLoginDisabled=false
  totalItems = 0;
  config: { itemsPerPage: number; currentPage: number; totalItems: number };
  allTotal: number = 0;
  isSearch: boolean = false;
  id: string;

  constructor(
   private authService:AuthService,
   private docHosService:HosdocService,
   private activatedRoute:ActivatedRoute,
   private router:Router,
   private conformatoionService:ConfirmationService,
   private messageService:MessageService


  ) {}

  ngOnInit() {

this.id=this.activatedRoute.snapshot.queryParams['id']
    this.initConfig()
    this.authService.authDataSubject.pipe(take(1)).subscribe(res=>{
      this.token=res._token
    })
    this.getDoctors(1)
}
  getDoctors(page) {
this.docHosService.getDoctorFromDb("",page,this.id).subscribe(res=>{
this.docArray=res.docData
this.config.currentPage=res.page;
this.config.totalItems=res.total
})
  }

initConfig() {
  this.config = {
    itemsPerPage: 10,
    currentPage: this.page,
    totalItems: this.totalItems
  };
}


  onSearchChange(value){

  }
  onAddDoctor(){
this.router.navigate(['register'],{
  relativeTo:this.activatedRoute,
preserveQueryParams:true
})
  }
  ondisabledDoctor(event,id){
    this.conformatoionService.confirm({
            message: "Are you sure that you want to perform this action?",
            accept: () => {
              this.docHosService.onDisableLogin(id, this.token).subscribe(res => {
               this.isLoginDisabled=res.isLoginDisabled
                this.messageService.add({
                  key: "tc",
                  severity: "success",
                  summary: "success",
                  detail: " login disabled status changed successfully",
                });
              },
              (error) => {
                this.messageService.add({
                  key: "tc",
                  severity: "success",
                  summary: " failed",
                  detail: "login disabled status not changrd due to unknown error",
                });
              }
              );
              //Actual logic to perform a confirmation
            }
          });
      
        //Actual logic to perform a confirmation
      
    
    event.stopPropagation();
  }
  onDeleteDoctors(event,id){
    this.conformatoionService.confirm({
      message: "Are you sure that you want to perform this action?",
      accept: () => {
        this.docHosService.onDelete(id, this.token).subscribe(res => {
this.getDoctors(this.config.currentPage)
        });
        //Actual logic to perform a confirmation
      }
    });
    event.stopPropagation();

  }
  pageChanged(event) {
    this.config.currentPage = event;
   
      this.getDoctors(this.config.currentPage);
    }
    onDoctorClicked(id){
this.router.navigate(['profile'],{
  relativeTo:this.activatedRoute,
  queryParams:{id:id}
  
  
})
    }

}
